import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonicModule, LoadingController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AplicativoProvider } from 'src/app/services/aplicativo/aplicativo';
import { UserProvider } from 'src/app/services/user/user';
import { Storage } from '@ionic/storage-angular';
import { NoticiaProvider } from 'src/app/services/noticia/noticia';
import { MensagemProvider } from 'src/app/services/mensagem/mensagem';
import { OracaoProvider } from 'src/app/services/oracao/oracao';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGeradorPage } from '../form-gerador/form-gerador.page';
import { LoginPage } from '../login/login.page';
import { ContribuicoesProvider } from 'src/app/services/contribuicoes/contribuicoes';
import { NoticiaPage } from '../noticia/noticia.page';
import { NoticiaDetalhesPage } from '../../components/noticia-detalhes/noticia-detalhes.page';
import { AcompanhamentoPage } from '../acompanhamento/acompanhamento.page';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { Browser } from '@capacitor/browser';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { TituloComponent } from 'src/app/components/titulo/titulo';
import { SliderNoticiaComponent } from 'src/app/components/slider-noticia/slider-noticia';
import { ListaNoticiaComponent } from 'src/app/components/lista-noticia/lista-noticia';
import { NoticiaDestaque } from 'src/app/components/noticia-destaque/noticia-destaque';
import { BotaoEscritoComponent } from 'src/app/components/botao-escrito/botao-escrito';
import { BotaoIconeComponent } from 'src/app/components/botao-icone/botao-icone';
import { BotaoImageComponent } from 'src/app/components/botao-image/botao-image';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { ConfiguracaoPage } from '../configuracao/configuracao.page';
import { ModalPessoaPage } from '../modal-pessoa/modal-pessoa.page';
import { ImagePipe } from 'src/app/pipes/image/image';
import { PessoaProvider } from 'src/app/services/pessoa/pessoa';
import { PessoaEditEnderecoPage } from '../pessoa/pessoa-edit-endereco/pessoa-edit-endereco.page';
import { AceitePrivacidadePage } from '../aceite-privacidade/aceite-privacidade.page';
import { SliderEventosComponent } from 'src/app/components/slider-eventos/slider-eventos';
import { NotificacaoPage } from '../notificacao/notificacao.page';

declare var instituicaoConstants: { TOKEN_ANONIMO: string; DARK: boolean; IS_PWA: boolean; };

const componentMap: Record<string, () => Promise<any>> = {
  InstituicaoPage: () =>
    import('../instituicao/instituicao.page').then(m => m.InstituicaoPage),
  MensagemPage: () =>
    import('../mensagem/mensagem.page').then(m => m.MensagemPage),
  SolicitacaoPage: () =>
    import('../solicitacao/solicitacao.page').then(m => m.SolicitacaoPage),
  PessoasContatoProfissaoPage: () =>
    import('../pessoa/pessoas-contato-profissao/pessoas-contato-profissao.page').then(m => m.PessoasContatoProfissaoPage),
  ProfissaoPage: () =>
    import('../pessoa/pessoas-contato-profissao/pessoas-contato-profissao.page').then(m => m.PessoasContatoProfissaoPage),
  NoticiaPage: () =>
    import('../noticia/noticia.page').then(m => m.NoticiaPage),
  AniversariantesPage: () =>
    import('../aniversariantes/aniversariantes.page').then(m => m.AniversariantesPage),
  PessoaPage: () =>
    import('../pessoa/pessoa.page').then(m => m.PessoaPage),
  MultiigrejaPage: () =>
    import('../multi-igreja/multi-igreja.page').then(m => m.MultiIgrejaPage),
  HinarioBuscaPage: () =>
    import('../hinario-busca/hinario-busca.page').then(m => m.HinarioBuscaPage),
  CultoPage: () =>
    import('../culto/culto.page').then(m => m.CultoPage),
  BibliaPage: () =>
    import('../biblia/biblia.page').then(m => m.BibliaPage),
  OracaoPage: () =>
    import('../oracao/oracao.page').then(m => m.OracaoPage),
  TestemunhoPage: () =>
    import('../oracao/oracao.page').then(m => m.OracaoPage),
  AcompanhamentoPage: () =>
    import('../acompanhamento/acompanhamento.page').then(m => m.AcompanhamentoPage),
  EnqueteListaPage: () =>
    import('../enquete-lista/enquete-lista.page').then(m => m.EnqueteListaPage),
  MdaPage: () =>
    import('../mda/mda.page').then(m => m.MdaPage),
  GrupoPage: () =>
    import('../grupo/grupo.page').then(m => m.GrupoPage),
  OvelhinhasPage: () =>
    import('../ovelhinhas/ovelhinhas.page').then(m => m.OvelhinhasPage),
  EventoPage: () =>
    import('../evento/evento.page').then(m => m.EventoPage),
  ContribuaPage: () =>
    import('../contribua/contribua.page').then(m => m.ContribuaPage),
  CalendarioPage: () =>
    import('../calendario/calendario.page').then(m => m.CalendarioPage),
  SantosPage: () =>
    import('../santos/santos.page').then(m => m.SantosPage),
  RecadastroPage: () =>
    import('../recadastro/recadastro.page').then(m => m.RecadastroPage),
  PedidoPreceGracaPage: () =>
    import('../pedido-prece-graca/pedido-prece-graca.page').then(m => m.PedidoPreceGracaPage),
  SoreiSaishiPage: () =>
    import('../sorei-saishi/sorei-saishi.page').then(m => m.SoreiSaishiPage),
  DonativosPage: () =>
    import('../donativos/donativos.page').then(m => m.DonativosPage),
  JohreiPage: () =>
    import('../johrei/johrei.page').then(m => m.JohreiPage),
  RelogioOracaoPage: () =>
    import('../relogio-oracao/relogio-oracao.page').then(m => m.RelogioOracaoPage),
  CentralPresencasPage: () =>
    import('../central-presencas/central-presencas.page').then(m => m.CentralPresencasPage),
};
@Component({
  selector: 'app-home-custom',
  templateUrl: './home-custom.page.html',
  styleUrls: ['./home-custom.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    DateFormatPipe,
    TranslateModule,
    TituloComponent,
    SliderNoticiaComponent,
    SliderEventosComponent,
    ListaNoticiaComponent,
    NoticiaDestaque,
    BotaoEscritoComponent,
    BotaoIconeComponent,
    BotaoImageComponent,
    LoadingSpinnerComponent,
    ImagePipe
  ],
})

export class HomeCustomPage implements OnInit {
  usuario: any = { id: 0, nome: '', foto: '', instituicao: {} };
  tokenAnonimo = "";
  informacoesAplicativo: any = {};
  isPWA: boolean = false;
  playingVideo = false;
  apiKey: string = "";
  menuType: string = 'overlay';
  dark: boolean;
  @ViewChild('home') home: any;
  tab: any;
  @ViewChild('video') video: ElementRef;
  tabSelecionada: any;
  backgroundContent = "linear-gradient(rgba(95, 95, 95, 0.66), rgba(95, 95, 95, 0.66))";
  colorIcons: any;
  isBarraAcao = false;
  isLayoutTabs = 0;
  iconsConfigs = false;
  pessoa: any = { endereco: {} };
  private isOpeningBrowser = false;
  isMessianica = false;
  notificationsLength = 0;

  constructor(
    public navCtrl: NavController,
    public contribuicoesProvider: ContribuicoesProvider,
    public aplicativoProvider: AplicativoProvider,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public userProvider: UserProvider,
    private location: Location,
    private noticiaProvider: NoticiaProvider,
    public oracaoProvider: OracaoProvider,
    public mensagemProvider: MensagemProvider,
    public storage: Storage,
    public router: Router,
    public alertCtrl: AlertController,
    public platform: Platform,
    public active: ActivatedRoute,
    public toastCtrl: ToastController,
    public pessoaProvider: PessoaProvider
  ) {
    this.isMessianica = environment.isMessianica;
    this.tokenAnonimo = instituicaoConstants.TOKEN_ANONIMO;
    this.dark = instituicaoConstants.DARK;
    this.isPWA = instituicaoConstants.IS_PWA;
    this.tabSelecionada = this.active.snapshot.paramMap.get('params');

    this.loadingCountNotification();
    this.userProvider.getDados().then(login => {
      if (this.isPWA && !login.isAnonimo) {
        this.userProvider.hasAceite('').subscribe(async aceite => {
          if (!aceite) {
            const modalPage = await this.modalCtrl.create({ component: AceitePrivacidadePage, componentProps: { tokenpush: '' } });
            modalPage.present();
          }
        });

      } else if (!this.isPWA && !login.isAnonimo) {
        this.userProvider.getTokenPush().then(tokenpush => {
          this.userProvider.hasAceite(tokenpush).subscribe(async aceite => {
            if (!aceite) {
              const modalPage = await this.modalCtrl.create({ component: AceitePrivacidadePage, componentProps: { tokenpush: (tokenpush ? tokenpush : '') } });
              modalPage.present();
            }
          });
        });
      }
      
      if(!login.isAnonimo) {
        this.verificaAtualizacao();
      }
    });
  }

  async verificaAtualizacao() {
    const date = new Date();
    const data = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    const storageResult = await this.storage.get('atualizar' + data);

    if (!storageResult) {
      setTimeout(() => {
        this.atualizarCadastro();
      }, 3000);
    }
  }

  ngOnInit() {
    this.loadHome();
  }

  async ionViewCanEnter() {
    if (this.userProvider.isAnonimo() && !this.tokenAnonimo) {
      this.userProvider.logout().then(() => {
        this.router.navigate(['login']);
      });
    } else {
      this.loadHome();

      this.userProvider.getDados().then(res => {
        if (res) {
          this.apiKey = res.apiKey;
          this.noticiaProvider.getInicioNoticias().subscribe();
          this.oracaoProvider.getInicioOracaoAdmin().subscribe();
          this.mensagemProvider.getInicioMensagens().subscribe();
        }
      });

      if (this.isPWA) {
        var token = window.location.href.replace(/.*t=([^&]*).*|(.*)/, '$1').split('#')[0];
        // let ovelinhas = this.navParams.get('ovelinhas');

        // if (ovelinhas) {
        //   const modalPage = await this.modalCtrl.create({ component: 'OvelinhasPage', componentProps: { token: true } });
        //   modalPage.present();
        // } else if (!ovelinhas && token) {
        //   var alteredURL = this.removeParam("t", window.location.href);
        //   alteredURL = this.removeParam("c", alteredURL);
        //   window.location.href = alteredURL.replace('?', '');
        // }

      }
    }
  }

  getIndex() {
    return '-9';
  }

  async alertLoadHome() {
    const alert = await this.alertCtrl.create({
      subHeader: this.translate.instant('Atenção'),
      message: this.translate.instant('Erro ao abrir aplicativo, entre em contato com sua igreja'),
      buttons: [
        {
          text: this.translate.instant('OK'),
          handler: () => {
            if (this.isMessianica) {
              this.router.navigateByUrl("onboarding");
            } else {
              this.router.navigateByUrl("LoginPage");
            }
          }
        }
      ]
    });

    alert.present();
  }

  loadHome() {
    this.informacoesAplicativo = this.aplicativoProvider.getDadosHome();
    this.isLayoutTabs = this.informacoesAplicativo.isLayoutTabs ?? 0;

    if (this.informacoesAplicativo.tipo_barra_acao === 2 && this.informacoesAplicativo.tabs.length > 1) {
      this.iconsConfigs = true;
    }

    this.onSegmentSelected(Number(this.tabSelecionada));

    this.informacoesAplicativo.tabs.forEach((element: { linhas: any[]; }) => {
      element.linhas.forEach((botoes: any[]) => {
        botoes.forEach((botao: { target_url: string; }) => {
          if (botao.target_url == 'RecadastroPage') {
            if (!this.userProvider.hasPermissao('PESSOA_EDITAR')) {
              botoes.splice(botoes.indexOf(botao), 1);
            }
          }
        });
      });
    });

    setTimeout(() => {
      this.playingVideo = true;

      if (this.video && this.video.nativeElement) {
        this.video.nativeElement.muted = true;
      }
    }, 1000);

    this.storage.get('inativa').then(data => {
      if (data) {
        this.alertLoadHome();
      }
    });
  }

  getDisplayTabs() {
    return this.isLayoutTabs == 0 ? 'contents' : 'flex';
  }

  onSegmentSelected(index: any) {
    this.tabSelecionada = index;
    const tab = this.informacoesAplicativo.tabs[this.tabSelecionada];

    this.colorIcons =
      this.informacoesAplicativo.tipo_barra_acao != 2 ? this.getActionColors(tab) : '#d9d9d9';

    this.backgroundContent = this.getBackground(tab);
    this.isBarraAcao = false;
    const tipo = this.informacoesAplicativo.tipo_barra_acao;
    const barra = tab.barra_acao;

    if (
      (tipo === 0 && barra === "1") ||
      (tipo === 1 && barra === "0") ||
      (tipo === 2 && barra === "0")
    ) {
      this.isBarraAcao = true;
    }
  }

  getBackground(tab: { background: string; degrade_inicio: string; degrade_fim: string; image: string; }) {
    if (tab.background == '1') {
      return " linear-gradient(" + tab.degrade_inicio + ", " + tab.degrade_fim + ")";
    } else if (tab.background == '2') {
      return " linear-gradient(" + tab.degrade_inicio + ", " + tab.degrade_fim + "), url('" + environment.DOWNLOAD_URL + "/" + tab.image + "') no-repeat scroll center center / cover";
    } else if (tab.background == '3') {
      return " linear-gradient(" + tab.degrade_inicio + ", " + tab.degrade_fim + "), url('../assets/imgs/gif.gif') no-repeat scroll center center / cover";
    }

    return '';
  }

  getBackgroundVideo(tab: { degrade_inicio: string; degrade_fim: string; }) {
    return " linear-gradient(" + tab.degrade_inicio + ", " + tab.degrade_fim + ")";
  }

  getMinHeight() {
    return (this.platform.height()) + 'px';;
  }

  getFont() {
    return this.informacoesAplicativo.font ? this.informacoesAplicativo.font : '';
  }

  getLetterSpacing() {
    return this.informacoesAplicativo.letter_spacing ? this.informacoesAplicativo.letter_spacing + 'px' : '';
  }

  getBackgroundColor() {
    return this.informacoesAplicativo.color ? this.informacoesAplicativo.color : '';
  }

  async botaoClick(botao: {
    token_flag: string;
    noticia_botao_texto: any;
    target_url: any;
    target_url_relogio: any;
    target: string;
    target_url_params: string;
    noticia: { id: any; };
    categorias_selecionadas: any;
    label: any;
    tipos_eventos: any;
  }) {
    if (botao.target === 'internal_eventos') {
      this.openPage('EventoPage', { categorias: botao.tipos_eventos});
      return;
    }

    if (botao.target === 'internal_ensinos') {
      this.openPage('EventoPage', { tipo: "2", categorias: botao.tipos_eventos});
      return;
    }

    if (botao.target_url_relogio === 'RelogioOracaoPage') {
      this.openPage('RelogioOracaoPage', {});
      return;
    }

    if (botao.target_url != 'DonativosPage' && (botao.token_flag === '0' || botao.token_flag === '1') && (botao.target === '_system' || botao.target === '_blank')) {
      botao.token_flag === '1' ? this.openLinkToken(botao.target_url, botao.target) : this.openInApp(botao.target_url, botao.target);
      return;
    } else if (botao.target_url === 'DonativosPage' && botao.token_flag === '1') {
      this.validaCep();
      return;
    }

    if (botao.token_flag === '1' && (botao.target === '_system' || botao.target === '_blank')) {
      this.openLinkToken(botao.target_url, botao.target);
    }

    const targetActions: Record<string, () => void | Promise<void>> = {
      '_system': () => this.openInApp(botao.target_url, botao.target),
      '_blank': () => this.openInApp(botao.target_url, botao.target),
      'internal': () => this.openPage(botao.target_url, JSON.parse(botao.target_url_params)),
      'internal_noticia': async () => {
        openPageWithData(NoticiaDetalhesPage, { id: botao.noticia.id });
      },
      'internal_categoria': async () => {
        openPageWithData(NoticiaPage, { categorias: botao.categorias_selecionadas, titulo: botao.label });
      },
      'noticia_mes': async () => {
        openPageWithData(NoticiaPage, { categorias: botao.categorias_selecionadas, titulo: botao.label, target: botao.target, texto: botao.noticia_botao_texto });
      },
      '_none': () => { /* faz nada fé */ },
    };

    const openPageWithData = async (page: any, data: any) => {
      (await this.modalCtrl.create({ component: page, componentProps: data })).present();
    };

    const internalPagesMap: Record<string, () => void> = {
      'ContribuaPage': () => this.openContribua(),
      'AcompanhamentoPage': () => this.openAcompanhamento(),
    };

    if (botao.target_url in internalPagesMap) {
      internalPagesMap[botao.target_url]();
    } else if (botao.target in targetActions) {
      targetActions[botao.target]();
    }
  }

  async validaCep() {
    if (!this.userProvider.isAnonimo()) {
      this.pessoaProvider.getbyId(this.userProvider.loggedUser.id).subscribe(data => {
        this.pessoa = data;
      });
    }

    const isAnonimo = this.userProvider.isAnonimo();
    const endereco = this.pessoa.endereco;

    if (!isAnonimo && !endereco.cep || !endereco.numero || !endereco.logradouro || !endereco.idCidade || !endereco.bairro || !endereco.idEstado) {
      const confirmAlert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Para continuar atualize seu endereço'),
        buttons: [
          {
            text: this.translate.instant('Ignorar'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('Atualizar'),
            handler: () => {
              this.editarEndereco(this.pessoa);
            },
          },
        ],
      });

      confirmAlert.present();
    } else {
      this.openLinkTokenDonativos();
    }
  }

  async editarEndereco(pessoa: any) {
    const data = { endereco: pessoa.endereco };
    const modalPage = await this.modalCtrl.create({ component: PessoaEditEnderecoPage, componentProps: data });
    modalPage.present();

    const result = (await modalPage.onDidDismiss());
    if (result && result.data.cep) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Endereço atualizado com sucesso!'),
        duration: 3000
      });

      toast.present();

      this.pessoa.endereco = result.data;
      this.openLinkTokenDonativos();
    } else {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Ops! Você precisa atualizar o cep'),
        duration: 3000
      });

      toast.present();
    }
  }

  async openLinkToken(link: any, target: any) {
    if (!this.userProvider.isAnonimo()) {
      this.pessoaProvider.getTokenTemp(null).subscribe(token => {
        Browser.open({ url: link + token.token });
      });

    } else {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Necessário Login'),
        message: this.translate.instant('Para utilizar essa funcionalidade é necessário fazer login'),
        buttons: [
          {
            text: this.translate.instant('Cancelar'),
            handler: () => { }
          },
          {
            text: this.translate.instant('Fazer Login'),
            handler: async () => {
              const modalPage = await this.modalCtrl.create({ component: LoginPage, componentProps: { 'mostrarHeader': true } });
              modalPage.present();
            }
          }
        ]
      });

      alert.present();
      return;
    }
  }

  async openLinkTokenDonativos() {
    if (!this.userProvider.isAnonimo()) {
      this.pessoaProvider.getLinkDonativos().subscribe(link => {
        Browser.open({ url: link.link });
      });

    } else {
      const alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Necessário Login'),
        message: this.translate.instant('Para utilizar essa funcionalidade é necessário fazer login'),
        buttons: [
          {
            text: this.translate.instant('Cancelar'),
            handler: () => { }
          },
          {
            text: this.translate.instant('Fazer Login'),
            handler: async () => {
              const modalPage = await this.modalCtrl.create({ component: LoginPage, componentProps: { 'mostrarHeader': true } });
              modalPage.present();
            }
          }
        ]
      });

      alert.present();
    }
  }

  openContribua() {
    if (this.informacoesAplicativo.novo_contribua && !this.userProvider.isAnonimo()) {
      this.openPage('ContribuaPage', {});

    } else if (this.informacoesAplicativo.novo_contribua && this.userProvider.isAnonimo()) {

      this.contribuicoesProvider.registrarTokenTemporario().subscribe((data) => {
        Browser.open({ url: data });
      });

    } else {
      Browser.open({ url: environment.URL_CONTRIBUA + this.userProvider.getToken() + '&from=APP' });
    }

  }

  async openInApp(url: string, type?: string) {
    if (!url || this.isOpeningBrowser) return;

    this.isOpeningBrowser = true;

    try {
      type === "_blank" ? Browser.open({ url }) : window.open(url);
    } finally {
      setTimeout(() => (this.isOpeningBrowser = false), 500);
    }
  }

  async AlertOpenAcompanhamento() {
    let alert = await this.alertCtrl.create({
      subHeader: this.translate.instant('Sem Acesso'),
      message: this.translate.instant('Você não possui acesso a essa funcionalidade'),
      buttons: [
        {
          text: this.translate.instant('Ok'),
          handler: () => { }
        }
      ]
    });
    alert.present();
  }

  async openAcompanhamento() {
    if (this.userProvider.hasPermissao('ACOMPANHAMENTO')) {
      (await this.modalCtrl.create({ component: AcompanhamentoPage })).present();
    } else {
      this.AlertOpenAcompanhamento();
    }
  }

  openLogin() {
    this.isMessianica ? this.router.navigateByUrl('onboarding') : this.router.navigate(['login']);
  }

  async alertOpenPage() {
    const alert = await this.alertCtrl.create({
      subHeader: this.translate.instant('Necessário Login'),
      message: this.translate.instant('Para utilizar essa funcionalidade é necessário fazer login'),
      buttons: [
        {
          text: this.translate.instant('Cancelar'),
        },
        {
          text: this.translate.instant('Fazer Login'),
          handler: async () => {
            this.router.navigate(['login']);
          }
        }
      ]
    });

    alert.present();
  }

  async openPage(page: any, params: { tipo?: any; categorias?: []}) {
    const isAnonimo = this.userProvider.isAnonimo();
    const allowedPages = [
      'PessoasContatoProfissaoPage',
      'OvelhinhasPage',
      'SolicitacaoPage',
      'OracaoPage',
      'MensagemPage',
      'GrupoPage',
      'MdaPage',
      'EnqueteListaPage',
      'CentralPresencasPage'
    ];

    if (isAnonimo && allowedPages.includes(page)) {
      this.alertOpenPage();
      return;
    }

    if (
      this.userProvider.hasConfig(184) &&
      page === 'OracaoPage' ||
      page === 'TestemunhoPage'
    ) {
      params = page === 'OracaoPage' ?
        { tipo: '1' } : { tipo: '2' };
    } else if (!this.userProvider.hasConfig(184) && page === 'OracaoPage') {
      params = { tipo: '0' };
    }

    if (
      this.userProvider.hasConfig(248) &&
      page === 'PessoasContatoProfissaoPage' ||
      page === 'ProfissaoPage'
    ) {
      params = page === 'PessoasContatoProfissaoPage' ? { tipo: '1' } : { tipo: '2' };
    }

    const loader = componentMap[page];
    if (!loader) return;

    const component = await loader();
    const modalProps = params ? { params: params.tipo, categorias: params.categorias ?? undefined } : {};

    (await this.modalCtrl.create({
      component,
      componentProps: modalProps
    })).present();
  }

  removeParam(key: string, sourceURL: string) {
    var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
  }

  async atualizarCadastro() {
    const dateFormat = this.getCurrentDateFormat();
    this.storage.set('atualizar' + dateFormat, true);

    this.aplicativoProvider.atualizarCadastro().subscribe(async (result: any) => {
      if (result) {
        await this.showUpdateAlert(result);
      }
    });
  }

  getCurrentDateFormat(): string {
    const date = new Date();
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }

  async showUpdateAlert(result: any) {
    (await this.alertCtrl.create({
      subHeader: this.translate.instant('Atualize seu cadastro'),
      message: this.translate.instant('Identificamos que faz tempo que você não atualiza seus dados pessoais'),
      buttons: [
        {
          text: this.translate.instant('Depois'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('Atualizar'),
          handler: () => {
            this.openCadastroModal(result);
          },
        },
      ],
    })).present();
  }

  async openCadastroModal(result: any) {
    const dados: any = {
      form: "APP_CAD_MEU",
      idPessoaTipo: result.tipo,
      titulo: this.translate.instant("Editar Meu Cadastro"),
      idPessoa: result.id,
    };

    dados.idInstituicao = result.idInstituicao;
    const modalPage = await this.modalCtrl.create({
      component: FormGeradorPage,
      componentProps: dados,
    });
    modalPage.present();
  }

  getActionWidth(btn: any): string {
    const tamanho = Number(btn.tamanho);
    const tipo = Number(btn.tipo_botao);

    // icone
    if (tipo === 2 && tamanho === 1) {
      return '4';
    } else if (tipo === 2 && tamanho === 2) {
      return '6';
    } else if (tipo === 2 && tamanho === 3) {
      return '12';
    } else if (tipo === 2 && tamanho === 4) {
      return '4';
    }

    if (
      tipo === 1 &&
      tamanho === 1
    ) {
      return '6';
    } else if (
      tipo === 1 &&
      tamanho === 5
    ) {
      return '8';
    } else if (
      tipo === 1
    ) {
      return '12';
    }

    if (
      tipo === 4 &&
      tamanho === 1
    ) {
      return '6';
    } else if (
      tipo === 4 &&
      tamanho === 2
    ) {
      return '12';
    }

    if (tamanho === 5) {
      return '6';
    } else if (tamanho === 4 && tipo === 2) {
      return '6';
    } else {
      return '12';
    }
  }

  async perfil(idPessoa: string) {
    const data = {
      idPessoa: idPessoa,
      meuCadastro: true,
      isTabs: false,
    };

    const modalPage = await this.modalCtrl.create({
      component: ModalPessoaPage,
      componentProps: data,
      id: 'modalPessoaId'
    });
    modalPage.present();
  }

  async configuracao() {
    this.userProvider.isAnonimo() ? this.alertOpenPage() : this.configuracaoPage();
  }

  async notificacoes(idPessoa: any) {
    this.userProvider.isAnonimo() ? this.alertOpenPage() : this.notificacaoPage(idPessoa);
  }

  getActionColors(tab: { barra_acao_cor: string }) {
    return tab.barra_acao_cor && tab.barra_acao_cor != '0'
      ? tab.barra_acao_cor + ''
      : 'rgb(255,255,255)';
  }

  async notificacaoPage(idPessoa: any) {
    const modalPage = await this.modalCtrl.create({
      component: NotificacaoPage,
      componentProps: idPessoa,
    });

    modalPage.present();

   (await modalPage.onDidDismiss()).data;
    this.loadingCountNotification()
  }

  loadingCountNotification() {
    if (!this.userProvider.isAnonimo()) {
      this.pessoaProvider.getCountNotification().subscribe((result) => {
        this.notificationsLength = result;
      });
    }
  }

  async configuracaoPage() {
    const modalPage = await this.modalCtrl.create({
      component: ConfiguracaoPage,
      componentProps: { meuCadastro: true },
    });

    modalPage.present();
  }

  isFirstOfTwoBotoesTipo1(index: number, line: any): boolean {
    const botoes = line.filter((f: { tipo_botao: string; }) => f.tipo_botao === '1');
    if (botoes.length === 2) {
      const idx1 = line.indexOf(botoes[0]);
      return index === idx1;
    }
    return false;
  }

  isSecondOfTwoBotoesTipo1(index: number, line: any): boolean {
    const botoes = line.filter((f: { tipo_botao: string; }) => f.tipo_botao === '1');
    if (botoes.length === 2) {
      const idx2 = line.indexOf(botoes[1]);
      return index === idx2;
    }
    return false;
  }

}
